import React from 'react';

import ImageWrapper from '../../components/UI/ImageWrapper/ImageWrapper';
import parse from 'html-react-parser';

import { UsefulLinks } from '@/components/UI';
import { Main, Row, SectionWrapper } from '@/components/layouts/Containers';

import { meta, orderData } from './HousingPrivileges.data';

import housingPrivilegesImage from 'assets/images/housing-privileges-image.jpg';

const HousingPrivileges = () => {
  return (
    <Main meta={meta}>
      <SectionWrapper pbNone className={'mt-6'}>
        <h1 className={'mb-6 titleHeader'}>Жилье по льготной стоимости</h1>

        <ImageWrapper image={housingPrivilegesImage.src} />
        <Row>
          <Row.Header>
            <h2>Порядок предоставления арендного жилья по льготной стоимости.</h2>
          </Row.Header>
          <Row.Content>
            {orderData.map((data) => (
              <p key={data.mainInfo}>
                <span>{data.mainInfo}</span>
                <br />
                <br />
                {parse(data.documentsNamesList)}

                {data.additionalInfo && (
                  <>
                    <br />
                    <br />
                    {parse(data.additionalInfo)}
                  </>
                )}
              </p>
            ))}
          </Row.Content>
        </Row>
      </SectionWrapper>

      <UsefulLinks />
    </Main>
  );
};

export default HousingPrivileges;
